import { render, staticRenderFns } from "./MediaItemDetail.vue?vue&type=template&id=0f7a040d&scoped=true&lang=pug"
import script from "./MediaItemDetail.vue?vue&type=script&lang=js"
export * from "./MediaItemDetail.vue?vue&type=script&lang=js"
import style0 from "./MediaItemDetail.vue?vue&type=style&index=0&id=0f7a040d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7a040d",
  null
  
)

export default component.exports